import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.bankSampah.tsx';
import '../index.css';

// Error Boundary Component
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error?: Error }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  override componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Application Error:', error, errorInfo);
  }

  override render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '2rem',
            textAlign: 'center',
            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
            backgroundColor: '#F9FAFB',
            color: '#374151'
          }}
        >
          <div
            style={{
              fontSize: '3rem',
              marginBottom: '1rem',
              color: '#DC2626'
            }}
          >
            ⚠️
          </div>
          <h1
            style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginBottom: '0.5rem',
              color: '#111827'
            }}
          >
            Oops! Terjadi kesalahan
          </h1>
          <p
            style={{
              fontSize: '1rem',
              marginBottom: '1.5rem',
              maxWidth: '400px',
              lineHeight: 1.5
            }}
          >
            Aplikasi mengalami masalah teknis. Silakan refresh halaman atau hubungi administrator.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              backgroundColor: '#2E7D32',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '0.75rem 1.5rem',
              fontSize: '0.875rem',
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: 'inherit'
            }}
          >
            Muat Ulang Halaman
          </button>
          {import.meta.env.MODE === 'development' && this.state.error && (
            <details
              style={{
                marginTop: '2rem',
                padding: '1rem',
                backgroundColor: '#FEF2F2',
                border: '1px solid #FECACA',
                borderRadius: '8px',
                maxWidth: '600px',
                textAlign: 'left',
                fontSize: '0.875rem'
              }}
            >
              <summary
                style={{
                  cursor: 'pointer',
                  fontWeight: 600,
                  color: '#DC2626',
                  marginBottom: '0.5rem'
                }}
              >
                Detail Error (Development Mode)
              </summary>
              <pre
                style={{
                  whiteSpace: 'pre-wrap',
                  overflow: 'auto',
                  fontFamily: 'monospace',
                  fontSize: '0.75rem',
                  color: '#7F1D1D'
                }}
              >
                {this.state.error.stack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

// Get the root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found! Make sure you have <div id="root"></div> in your HTML.');
}

// Prevent multiple createRoot calls during development (HMR)
declare global {
  interface Window {
    __reactRoot?: ReactDOM.Root;
  }
}

let root: ReactDOM.Root;

if (!window.__reactRoot) {
  root = ReactDOM.createRoot(rootElement);
  window.__reactRoot = root;
} else {
  root = window.__reactRoot;
}

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);